import React from "react";
import { FormControl, Container, Row, Col } from "react-bootstrap";
import moment from "moment-timezone";
import DateTimeRangeContainer from "./lib/index";
import { isFirefoxBelow53 } from "./lib/utils/BrowserVersion";
class Wrapper extends React.Component {
  constructor(props) {
    super(props);

    // Default Selected Date Range

    let start = moment()
      .subtract(this.props.defaultDays - 1 || 4, "days")
      .startOf("day");
    let end = moment();

    // To Check if customSelectedDateTime is provided and valid
    if (this.props.customSelectedDateTime && this.props.customSelectedDateTime.length === 2 
      && (this.props.customSelectedDateTime[0] !== this.props.customSelectedDateTime[1])
      && (this.props.isCustomSelected)
      ) {
      start = moment(this.props.customSelectedDateTime[0]);
      end = moment(this.props.customSelectedDateTime[1]);
    }

    this.state = {
      start: start,
      end: end,
      timezone: "America/Los_Angeles",
      secondDisplay: false,
      formattedDateTime: "",
      startTime: "",
      endTime: "",
      errorMessage: "",
      errorMessageType: "",
      isErrorActive: false,
      maxRange: 0,
      duration_type: "",
      maxRangeError: ""
    };

    this.onClick = this.onClick.bind(this);
    this.applyCallback = this.applyCallback.bind(this);
  }

  componentDidMount() {
    if (this.props.customSelectedDateTime && this.props.customSelectedDateTime.length === 2 
      && (this.props.customSelectedDateTime[0] !== this.props.customSelectedDateTime[1])
      && (this.props.isCustomSelected)
      ) {
      const start = moment(this.props.customSelectedDateTime[0]);
      const end = moment(this.props.customSelectedDateTime[1]);
      this.setState({ start, end });
    }
  }

  formatDate = (dateTimeString) => {
    if (typeof dateTimeString !== "string") {
      return "Invalid input";
    }

    const [date, time] = dateTimeString.split(" ");
    if (!date || !time) {
      return "Invalid input";
    }

    const [day, month, year] = date.split("-");
    const [hours, minutes] = time.split(":");
    const amPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedDateTime = `${year}/${month}/${day} ${formattedHours}:${minutes} ${amPm}`;
    this.setState({
      formattedDateTime: { formattedDateTime }.formattedDateTime,
    });
    return formattedDateTime;
  };

  
  applyCallback(startDate, endDate) {
    // Calculating the selectionRange Time Difference in Days
    let startTime = new Date(this.props.selectionRange[0]);
    let endTime = new Date(this.props.selectionRange[1]);
    let daysRangeDifference;
    let monthsRangeDifference;
    const diffInDays = endDate.diff(startDate, "days");

    if (this.props.selectionRangeType === "day") {
      let timeDifferenceInMilliseconds =
        endTime.getTime() - startTime.getTime();
      let timeDifferenceInHours =
        timeDifferenceInMilliseconds / (1000 * 60 * 60);
      daysRangeDifference = timeDifferenceInHours / 24;
    }

    // Define a function to generate the error message
    const generateRangeError = (maxRange, durationType) => {
      return `${maxRange} ${durationType}`;
    };

    if (diffInDays > daysRangeDifference - 1) {
      this.setState({
        maxRange: daysRangeDifference,
        duration_type: "days",
        maxRangeError: generateRangeError(daysRangeDifference, "days"),
        errorMessageType: "rangeError",
        isErrorActive: true
      });
      // console.log("daysRangeDifference", daysRangeDifference);
      // return;
    }

    if (this.props.selectionRangeType === "month") {
      let startDate = moment(this.props.selectionRange[0]);
      let endDate = moment(this.props.selectionRange[1]);

      let diffYears = endDate.diff(startDate, "years");
      let diffMonths = endDate.diff(startDate, "months") % 12;

      monthsRangeDifference = diffYears * 12 + diffMonths;
      // console.log("Month Duration Difference:", monthsRangeDifference);
      // console.log("startDate:", startDate);
      // console.log("endDate:", endDate);
    }

    const diffInMonths = endDate.diff(startDate, "months");

    if (diffInMonths > monthsRangeDifference - 1) {
      this.setState({
        maxRange: monthsRangeDifference,
        duration_type: "months",
        maxRangeError: generateRangeError(monthsRangeDifference, "months"),
        errorMessageType: "rangeError",
        isErrorActive: true
      });
      // return;
    }

    if (this.props.pastDate) {
      let currentDate = new Date();
      let diffYears =
        currentDate.getFullYear() - this.props.pastDate.getFullYear();
      let diffMonths =
        diffYears * 12 +
        currentDate.getMonth() -
        this.props.pastDate.getMonth();

      // console.log("diffMonths", diffMonths);
      // console.log("diffYears", diffYears);

      if (this.props.pastDateType === "year") {
        if (
          moment(startDate).isBefore(moment().subtract(diffYears, "year")) ||
          moment(endDate).isBefore(moment().subtract(diffYears, "year"))
        ) {
          if (diffYears === 1) {
            this.setState({
              errorMessageType: "durationError",
              isErrorActive: true
            });
          } else {
            this.setState({
              errorMessageType: "durationError",
              isErrorActive: true
            });
          }
          // return;
        }
      }
      
      if (this.props.pastDateType === "month") {
        if (
          moment(startDate).isBefore(moment().subtract(diffMonths, "months")) ||
          moment(endDate).isBefore(moment().subtract(diffMonths, "months"))
        ) {
          this.setState({
            errorMessageType: "durationError",
            isErrorActive: true
          });
          // return;
        }
      }
    } else {
      const restrictionDate = moment("2023-01-01", "YYYY-MM-DD");
      if (startDate.isBefore(restrictionDate) || endDate.isBefore(restrictionDate)) {
        this.setState({
          errorMessageType: "durationError",
          isErrorActive: true
        });
        // return;
      }
    }

    this.setState(
      {
        start: startDate,
        end: endDate,
      },
      () => {
        const dateTimeString1 = startDate.format("DD-MM-YYYY HH:mm");
        const formattedStartDate = this.formatDate(dateTimeString1);
        this.setState({ startTime: formattedStartDate });

        const dateTimeString2 = endDate.format("DD-MM-YYYY HH:mm");
        const formattedEndDate = this.formatDate(dateTimeString2);
        this.setState({ endTime: formattedEndDate });

        this.sendDataToParent();
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.startTime !== prevState.startTime ||
      this.state.endTime !== prevState.endTime
    ) {
      this.sendDataToParent();
    }
    if (this.state.errorMessage) {
      this.sendDataToParent();
    }
  }

  sendDataToParent = () => {
    const { startTime, endTime, errorMessage, errorMessageType, isErrorActive, maxRangeError} = this.state;
    if (startTime && endTime) {
      this.props.onData(startTime, endTime, errorMessage, errorMessageType, isErrorActive, maxRangeError);
      // console.log("Sending data to parent:", startTime, endTime, errorMessage, errorMessageType);
    }

    if (errorMessage) {
      this.props.onData( startTime, endTime, errorMessage, errorMessageType, isErrorActive, maxRangeError);
      // console.log("Sending Error Data to parent:", startTime, endTime, errorMessage, errorMessageType, isErrorActive, maxRangeError);
    }
  };

  rangeCallback(index, value) {
    console.log(index, value);
  }

  onClick() {
    let newStart = moment(this.state.start).subtract(3, "days");
    // console.log("On Click Callback");
    // console.log(newStart.format("DD-MM-YYYY HH:mm"));
    this.setState({ start: newStart });
  }

  renderTwelveHourPicker(ranges, local, maxDate) {
    let value = `${this.state.start.format(
      "DD-MM-YYYY HH:mm"
    )} - ${this.state.end.format("DD-MM-YYYY HH:mm")}`;

    let firefoxBelow35 = isFirefoxBelow53();
    let disabled = true;
    if (firefoxBelow35) {
      disabled = false;
    }

    return (
      <div>
        <div id="DateTimeRangeContainerTimezone">
          <DateTimeRangeContainer
            ranges={ranges}
            start={this.state.start}
            end={this.state.end}
            local={local}
            maxDate={maxDate}
            applyCallback={this.applyCallback}
            rangeCallback={this.rangeCallback}
            twelveHoursClock={true}
            finalStartDate={this.state.startTime}
            finalEndDate={this.state.endTime}
            customSelectedDateTime={this.props.customSelectedDateTime}
          >
            <FormControl
              id="formControlsTextB"
              type="text"
              label="Text"
              placeholder="Enter text"
              style={{ cursor: "pointer" }}
              disabled={disabled}
              value={null}
            />
          </DateTimeRangeContainer>
        </div>
      </div>
    );
  }

  render() {
    let now = new Date();
    let start = moment(
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
    );
    let end = moment(start).add(1, "days").subtract(1, "seconds");
    let ranges = {
      "Last 1 Hour": [moment(start).subtract(1, "hours"), moment(end)],
      "Last 3 Hours": [moment(start).subtract(3, "hours"), moment(end)],
      "Last 6 Hours": [moment(start).subtract(6, "hours"), moment(end)],
      "Last 12 Hours": [moment(start).subtract(12, "hours"), moment(end)],
      "Last 24 Hours": [moment(start).subtract(24, "hours"), moment(end)],
    };
    let local = {
      format: "DD-MM-YYYY HH:mm",
      sundayFirst: false,
    };

    let maxDate = moment().endOf("day");

    let pickers = this.renderTwelveHourPicker(ranges, local, maxDate, true);

    return <div className="container">{pickers}</div>;
  }
}
export { Wrapper };
